module.exports = __webpack_public_path__ + "static/avatar_leisan_utyasheva-74c9bbcd36b358d385b8ad4ed409cd5d.jpg";